"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
/**
 * 模拟类组件的setState带回调功能
 * @param initialState
 * @returns
 */
function useStateWithCallback(initialState) {
  var _useState = (0, _react.useState)(initialState),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var callbackRef = (0, _react.useRef)(null);
  var setStateWithCallback = function setStateWithCallback(newState, callback) {
    // 保存回调函数
    callbackRef.current = callback;
    setState(newState);
  };
  (0, _react.useEffect)(function () {
    if (callbackRef.current) {
      // 执行回调函数
      callbackRef.current(state);
      // 清空回调函数
      callbackRef.current = null;
    }
  }, [state]);
  return [state, setStateWithCallback];
}
var _default = exports.default = useStateWithCallback;